module.exports = "<a aria-controls=\"profilePopover\" aria-haspopup=\"true\" ng-class=\"{opened: $ctrl.opened}\" ng-click=\"$ctrl.toggle()\">\n  <img ng-src=\"{{$ctrl.profilePicLink}}\" alt=\"Profile picture\" class=\"profile-img\" />\n  <span class=\"user-name\">{{$ctrl.userName}}</span><span class=\"icon ico-arrow-down\"></span>\n</a>\n<!-- .trigger-popup END -->\n\n<!-- aria-hidden should become false once the popup shows up -->\n<div class=\"popup\" tabindex=\"-1\" aria-hidden=\"true\" ng-transclude=\"popup\">\n\n</div>\n<!-- .popup END -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpDropdown/adpDropdown.html
// module id = 531
// module chunks = 0